// Compiled regex patterns for reuse
export const HTML_TAGS_REGEX = /<[^>]*>/g;
export const PUNCTUATION_REGEX = /[.,/#!$%^&*;:{}=\-_`~()]/g;
export const WORD_BOUNDARY_REGEX = /\w/;

// Czech language specific constants for stemming
export const CZECH_SUFFIXES = ['it', 'ení', 'ání', 'y', 'a', 'e', 'u', 'ů', 'ích', 'ovat', 'ování', 'ová', 'ovati'];

export const STEMMING_PATTERNS = [/(it|ení|ání|y|a|e|u|ů|ích|ích|ích|ích)$/i, /(ovat|ování|ová|vati)$/i];
